import {defineStore} from "pinia";
import {ref} from "vue";

export default defineStore('priceHiderStore', () => {
    const pricesHidden = ref(false);
    const togglePrices = () => {
        pricesHidden.value = !pricesHidden.value;
    }
    return { pricesHidden, togglePrices };
}, {
    persist: !import.meta.env.SSR,
})
